const BREADCRUMBS_SET = 'BREADCRUMBS_SET'

export function setBreadcrumbs( breadcrumbs ) {
  return { 
    type : BREADCRUMBS_SET,
    breadcrumbs
  };
}

export function addBreadcrumbs( breadcrumbs ) {
  const newState = state.concat( breadcrumbs )
  return { 
    type : BREADCRUMBS_SET,
    breadcrumbs : newState
  };
}

module.exports = {
  BREADCRUMBS_SET,
  setBreadcrumbs
}
